import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import { useInView } from '@/hooks/useInView';

export default function PopularArticles() {
  const featured = getFeaturedArticles().slice(0, 3);
  const { ref, isInView } = useInView(0.05);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
              热门推荐
            </h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">
              最受情侣欢迎的旅行攻略和浪漫灵感
            </p>
          </div>
          <Link
            to="/category/date-guide"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((article, index) => (
            <article key={article.id} className={`bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${index * 150}ms` }}>
              <Link to={`/article/${article.id}`}>
                <div className={`relative overflow-hidden ${index === 0 ? 'h-64 md:h-full' : 'h-48'}`}>
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {index === 0 && (
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full whitespace-nowrap">
                        编辑精选
                      </span>
                    </div>
                  )}
                </div>
              </Link>
              <div className={`p-5 ${index === 0 ? 'md:p-8 flex flex-col justify-center' : ''}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3 flex-wrap">
                  <Link
                    to={`/category/${article.categorySlug}`}
                    className="px-2.5 py-1 bg-secondary-100 text-secondary-700 rounded-full font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
                  >
                    {article.categoryName}
                  </Link>
                  <span>{article.date}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
                <Link to={`/article/${article.id}`}>
                  <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors ${index === 0 ? 'text-xl md:text-2xl mb-3' : 'text-lg mb-2'}`}>
                    {article.title}
                  </h3>
                </Link>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm"></i>
                    {article.viewCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line text-sm"></i>
                    {article.likeCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="sm:hidden mt-6 text-center">
          <Link
            to="/category/date-guide"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}